var React = require('react');

function MajorCash (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.47 7.25H20v-1a1.5 1.5 0 0 0-1.5-1.5h-15A1.5 1.5 0 0 0 2 6.25v9a1.5 1.5 0 0 0 1.5 1.5H4v1a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.53-1.5zm-17 8v-9h15v1h-13A1.5 1.5 0 0 0 4 8.75v6.5h-.53zm2 2.5h15v-9h-15v9zM13 10.5a2.77 2.77 0 0 0-2.76 2.76 2.67 2.67 0 0 0 .87 2 2.73 2.73 0 0 0 3.78 0 2.67 2.67 0 0 0 .87-2A2.77 2.77 0 0 0 13 10.5zm-1.165 3.22c.194.472.654.78 1.165.78v.01a1.26 1.26 0 0 0 1.26-1.26 1.26 1.26 0 1 0-2.425.47z","fill":"#000"}));
}

MajorCash.defaultProps = {"width":"40","height":"40","viewBox":"0 0 24 24","fill":"none"};

module.exports = MajorCash;

MajorCash.default = MajorCash;
